// extracted by mini-css-extract-plugin
export default {"warn":"QuoteRecallDate_warn__Z2n9L","info":"QuoteRecallDate_info__5qU+a"};